// extracted by mini-css-extract-plugin
export var body = "_3o-1";
export var bodyPadded = "_3o-2";
export var chevron = "_3o-4";
export var chevronOpen = "_3o-5";
export var header = "_3o-0";
export var icon = "_3o-3";